import React from 'react';
import PaneHeadline from '../../shared/paneHeadline';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { locale } from '../../../common/localization/localizationService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SimpleReactLightBox, { SRLWrapper } from 'simple-react-lightbox';
import { getExecutedIcon } from '../../../utils/GeneralUtils';
import { ICustomerLog } from '../../../models/CustomerLogs.model';

export interface ICustomerLogDetailsProps {
  customerLog: ICustomerLog;
  match: any;
}

export default function CustomerLogDetails(
  props: ICustomerLogDetailsProps
): JSX.Element {
  const backUrl = props.match?.url.substring(
    0,
    props.match?.url.indexOf('/' + 'customerLogDetails')
  );

  const lightboxOptions = {
    settings: {
      autoplaySpeed: 0,
      disableWheelControls: true,
    },
    buttons: {
      showAutoplayButton: false,
      showDownloadButton: false,
    },
  };
  const address = props.customerLog.estate;
  const pictureUrl = props.customerLog.deviationPicture;
  return (
    <div className="customer-log-details-view">
      <PaneHeadline
        titleText={address}
        titleIcon={faInfo}
        backUrl={backUrl}
        backTitle={locale.customerLogs._customerLogs}
      />

      <div className="row">
        <div className="col-12">
          <div className="card mb-3">
            <div className="card-body details-container">
              <div className="cell">
                <div className="label">{locale.customerLogs._agreementId}</div>
                <div className="value">{props.customerLog.agreementId}</div>
              </div>
              <div className="cell">
                <div className="label">{locale.customerLogs._name}</div>
                <div className="value">{props.customerLog.name}</div>
              </div>
              <div className="cell">
                <div className="label">{locale.customerLogs._address}</div>
                <div className="value">{address}</div>
              </div>
              <div className="cell">
                <div className="label">{locale.customerLogs._arrivalTime}</div>
                <div className="value">
                  {moment(new Date(props.customerLog.time)).format(
                    locale.general._fullMomentWithTime
                  )}
                </div>
              </div>
              <div className="cell">
                <div className="label">{locale.customerLogs._executed}</div>
                <div className="value">
                  <FontAwesomeIcon
                    icon={getExecutedIcon(props.customerLog.message)}
                  />
                </div>
              </div>
              <div className="cell">
                <div className="label"></div>
                <div className="value"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {props.customerLog.comment && (
        <div className="card mb-3">
          <div className="card-header">
            <h3>{locale.customerLogs._comment}</h3>
          </div>
          <div className="card-body">
            <p className="card-text">{props.customerLog.comment}</p>
          </div>
        </div>
      )}

      {props.customerLog &&
        props.customerLog.dataButtonValues &&
        props.customerLog.dataButtonValues.length > 0 && (
          <div className="card mb-3">
            <div className="card-header">
              <h3>{locale.customerLogs._orderData}</h3>
            </div>
            <ul className="list-group list-group-flush">
              {props.customerLog.dataButtonValues.map((dataButton) => (
                <li className="list-group-item" key={dataButton.tag}>
                  {dataButton.text}: {dataButton.value}
                </li>
              ))}
            </ul>
          </div>
        )}

      {props.customerLog &&
        props.customerLog.unitDeviations &&
        props.customerLog.unitDeviations.length > 0 && (
          <div className="card mb-3">
            <div className="card-header">
              <h3>{locale.customerLogs._deviation}</h3>
            </div>
            <ul className="list-group list-group-flush">
              {props.customerLog.unitDeviations &&
                props.customerLog.unitDeviations.map(
                  (deviation: string, i: number) => (
                    <li className="list-group-item" key={i}>
                      {deviation}
                    </li>
                  )
                )}
            </ul>
          </div>
        )}

      {pictureUrl && (
        <div className="card">
          <div className="card-header">
            <h3>{locale.customerLogs._pictures}</h3>
          </div>
          <div className="card-body">
            <SimpleReactLightBox>
              <SRLWrapper options={lightboxOptions}>
                <div className="row pictures-row">
                  {pictureUrl.map((url: string) => (
                    <div key={url} className="col-md-2 picture">
                      <a href={url} target="_blank" rel="noopener noreferrer">
                        <img src={url} />
                      </a>
                    </div>
                  ))}
                </div>
              </SRLWrapper>
            </SimpleReactLightBox>
          </div>
        </div>
      )}
    </div>
  );
}
